const WALLET_TYPES = {
  LEDGER: 'ledger',
  TREZOR: 'trezor',
  BITBOX2: 'bitbox02',
  KEEPKEY: 'keepkey',
  MEW_CONNECT: 'mew_connect',
  WALLET_CONNECT: 'walletConnect',
  KEYSTORE: 'keystore',
  MNEMONIC: 'mnemonic',
  WEB3_WALLET: 'web3Wallet',
  PRIV_KEY: 'privKey',
  COOL_WALLET: 'coolWallet',
  WALLET_LINK: 'walletLink',
  MEW_WALLET: 'mewWallet'
};
export default WALLET_TYPES;
